
import React from 'react';

interface WarningIconProps {
  className?: string;
  size?: number;
  color?: string;
}

const WarningIcon: React.FC<WarningIconProps> = ({
  className = '',
  size = 24,
  color = '#FF8A00',
}) => (
  <svg width={size} className={className} 
    height={size} viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path fillRule="evenodd" clipRule="evenodd" d="M10.3386 3.04487C11.1284 
    1.65171 13.1919 1.65171 13.9818 3.04488L21.8999 17.0112C22.6619 18.3554 
    21.6595 20 20.0783 20H4.24205C2.66081 20 1.65842 18.3554 2.42046 17.0112L10.3386 
    3.04487ZM13.6583 16.4994C13.6583 17.3278 12.9867 17.9994 12.1583 17.9994C11.3299 
    17.9994 10.6583 17.3278 10.6583 16.4994C10.6583 15.671 11.3299 14.9994 12.1583 
    14.9994C12.9867 14.9994 13.6583 15.671 13.6583 16.4994ZM12.1602 14C11.7733 14 
    11.4411 13.7251 11.3687 13.3451L10.3863 8.18711C10.2689 7.57088 10.7413 7 11.3686 
    7L12.9517 7C13.579 7 14.0514 7.57088 13.934 8.18711L12.9516 13.3451C12.8792 13.7251 
    12.547 14 12.1602 14Z" fill={color} />
  </svg>
);

export default WarningIcon;
